<template>
  <router-link
    :to="{
      name: 'routeinfo',
      query: {
        routedir: stopItem.routedir,
        stopseq: stopItem.stopseq,
      },
    }"
    class="each-stop-a"
    @click="prepareOpenStopMenu(stopItem)"
  >
    <div class="stop-index">
      {{ stopSeq + 1 }}
    </div>
    <div class="stop-name">
      {{ stopItem.stopc }}
    </div>
  </router-link>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: 'RouteStopItem',
  props: [
    'stopItem', 'stopSeq',
  ],
  methods: {
    ...mapState('routeInfo', ['routeDetails']),
    ...mapActions('stopMenu', ['openStopMenu']),
    ...mapMutations('googleMap', [
      'openOnlyInfoWindow', 'updateBound',
      'cleanRouteLine', 'cleanMarkers',
    ]),
    ...mapActions('googleMap', ['getRouteLine']),

    async prepareOpenStopMenu(stopItem) {
      const {
        routedir, stopseq,
        // company_service_type, company_stopseq, company_routedir,
      } = stopItem;

      const {
        // startc, destinc,
        routeid, routec,
      } = this.routeDetails;

      const stopDetails = await this.openStopMenu({
        routeid,
        routedir,
        stopseq,
      });

      this.openOnlyInfoWindow(stopItem);
      this.updateBound([
        {
          ...stopItem,
          ...stopDetails,
          position: {
            lat: stopDetails.lat,
            lng: stopDetails.lng,
          },
        },
      ]);

      this.getRouteLine({
        routeid,
        routedir,
        routec,
        stopseq,
      });
    },

  },
}
</script>
<style scoped>
a.each-stop-a {
  cursor: pointer;
  display: flex;
  width: 100%;
  padding: 4px;
}
.stop-index{
  margin-right: 6px;
}
</style>
